import { Link, useLocation } from "react-router-dom";
import { Home, Package, ShoppingBag, Store, User } from "lucide-react";

/**
 * SMART Bottom Navigation Bar (mobile-only).
 *
 * Sticks to the bottom of the viewport on screens < 768px. Hidden on desktop
 * where the top Header nav handles everything.
 *
 * Icons/Links: Home · Shipping · Services · Market · Account
 * Style: matte black background, gold (#FFD700) accents on the active tab.
 */
const TABS = [
    { id: "home",     label: "Home",     Icon: Home,        to: "/home",         match: ["/home", "/"] },
    { id: "shipping", label: "Shipping", Icon: Package,     to: "/shipping",     match: ["/shipping", "/logistics"] },
    { id: "services", label: "Services", Icon: ShoppingBag, to: "/services",     match: ["/services", "/vehicles"] },
    { id: "market",   label: "Market",   Icon: Store,       to: "/marketplace",  match: ["/marketplace", "/giftcards", "/send-home"] },
    { id: "account",  label: "Account",  Icon: User,        to: "/my-bookings",  match: ["/my-bookings", "/provider", "/admin", "/account"] },
];

// Hide the bar on focused auth flows so we don't push the form up.
const HIDDEN_ROUTES = [
    "/auth",
    "/forgot-password",
    "/reset-password",
    "/verify-email",
    "/payment-success",
    "/payment-cancelled",
];

export default function BottomNavBar() {
    const location = useLocation();
    const path = location.pathname || "/";

    if (HIDDEN_ROUTES.some((r) => path === r || path.startsWith(r + "/"))) {
        return null;
    }

    return (
        <nav
            className="bottom-nav-bar md:hidden"
            aria-label="Primary mobile navigation"
            data-testid="bottom-nav-bar"
        >
            {TABS.map(({ id, label, Icon, to, match }) => {
                const active = match.some((m) => path === m || path.startsWith(m + "/"));
                return (
                    <Link
                        key={id}
                        to={to}
                        className={`bottom-nav-item ${active ? "is-active" : ""}`}
                        data-testid={`bottom-nav-${id}`}
                        aria-current={active ? "page" : undefined}
                    >
                        <span className="bottom-nav-icon" aria-hidden="true">
                            <Icon size={20} strokeWidth={1.6} />
                        </span>
                        <span className="bottom-nav-label">{label}</span>
                    </Link>
                );
            })}
        </nav>
    );
}
